import {useDispatch, useSelector} from "react-redux";
import ChatParticipant from "./chat-participant";
import {
    setWorkspaceGraphChatParticipants,
    upsertWorkspaceChatParticipant,
} from "../../system/workspace-graph-slice";
import {
    normalizeMembershipEntity,
    prepareMembershipPayload,
} from "../workspace-membership/workspace-membership-identity";

const populate = {
    chat: true,
    user: {populate: {member: {populate: {profileImage: true}}}},
};

export function useChatParticipant() {
    const dispatch = useDispatch();
    const workspaceMembership = useSelector((state) => state.app?.workspaceMembershipData);
    const memberships = workspaceMembership?.workspace?.workspace_memberships || [];

    const getChatParticipants = async () => {
        const response = await new ChatParticipant().getAll({
            populate,
            sort: ["isPinned:desc", "updatedAt:desc"],
            pagination: {pageSize: 200},
        });
        const items = (response?.data || []).map((item) =>
            normalizeMembershipEntity(item, "chatParticipant", memberships));
        dispatch(setWorkspaceGraphChatParticipants(items));
        return items;
    };

    const getChatParticipant = async (documentId) => {
        try {
            const response = await new ChatParticipant().getById(documentId, {populate});
            return normalizeMembershipEntity(response?.data, "chatParticipant", memberships) || null;
        } catch (error) {
            if ([403, 404].includes(error?.status)) return null;
            throw error;
        }
    };

    // options.quiet: a background write (presence: typing / sending a file) whose failure is not shown as an error
    const updateChatParticipant = async (documentId, data, options = {}) => {
        const payload = prepareMembershipPayload("chatParticipant", data, memberships, {
            currentMembership: workspaceMembership,
            operation: "update",
        });
        const response = await new ChatParticipant().update(documentId, payload, {populate}, undefined, options.quiet ? {suppressGlobalErrorHandler: true} : {});
        const item = normalizeMembershipEntity(response?.data, "chatParticipant", memberships);
        if (item) dispatch(upsertWorkspaceChatParticipant(item));
        return item;
    };

    return {getChatParticipants, getChatParticipant, updateChatParticipant};
}
